export const FORGOT_PASSWORD_EMAIL_STATUSES = {
    ongoing: 'FORGOT_PASSWORD_EMAIL_ONGOING',
    delivered: 'FORGOT_PASSWORD_EMAIL_DELIVERED',
    failed: 'FORGOT_PASSWORD_EMAIL_FAILED',
};

export const SOFT_ACCOUNT_EMAIL_STATUSES = {
    ongoing: 'SOFT_ACCOUNT_EMAIL_ONGOING',
    delivered: 'SOFT_ACCOUNT_EMAIL_DELIVERED',
    failed: 'SOFT_ACCOUNT_EMAIL_FAILED',
};

export const PASSWORDLESS_EMAIL_STATUSES = {
    ongoing: 'PASSWORDLESS_EMAIL_ONGOING',
    delivered: 'PASSWORDLESS_EMAIL_DELIVERED',
    failed: 'PASSWORDLESS_EMAIL_FAILED',
    limitReached: 'PASSWORDLESS_EMAIL_LIMIT_REACHED',
};
